var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_state_wrap"},[_c('div',{staticClass:"state_box"},[_c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":_vm.showInfo.img}})]),_c('h5',[_vm._v(_vm._s(_vm.showInfo.text))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }